const NoDataFound = () => {
  return (
    <tr>
      <td colSpan="7" className="text-center">
      No Data Found
      </td>
    </tr>
  );
};
export default NoDataFound;